import { APP_CONSTANT } from "model/constants/actionConstants";

const onShowDrawer = () => ({
	type: APP_CONSTANT.SET_SHOW_DRAWER_MENU,
	payload: true,
});

const onCloseDrawer = () => ({
	type: APP_CONSTANT.SET_SHOW_DRAWER_MENU,
	payload: false,
});

const APP_ACTION = {
	onShowDrawer,
	onCloseDrawer,
};

export default APP_ACTION;
